<template>
  <div>
    <p v-if="!offers.length" class="text-body-2">No hay partners activos en este país.</p>
    <div v-for="offer in offers" :key="offer.id" class="mb-6">
      <h4 class="text-subtitle-1 font-weight-bold mb-1">{{ offer.partnerName }}</h4>
      <p v-if="!offer.margins" class="text-body-2">Sin foto calculada todavía.</p>
      <div v-for="(table, tableIndex) in offer.margins || []" :key="table.title" class="mb-4">
        <div class="text-caption mb-1">
          {{ table.title }} · costo por membresía
        </div>
        <v-simple-table dense class="actuarial__table">
          <thead>
            <tr>
              <th>Tramo</th>
              <th v-for="column in offer.priceTables[tableIndex].columns" :key="column" class="text-right">{{ column }}</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="row in table.rows" :key="row.range">
              <td>{{ row.range }}</td>
              <td v-for="cell in row.cells" :key="cell.plan" class="text-right">
                <div>{{ money(cell.price) }} · <strong>{{ marginText(cell) }}</strong></div>
                <div class="text-caption">costo {{ money(cell.costPerUnit) }}</div>
              </td>
            </tr>
          </tbody>
        </v-simple-table>
        <p v-if="unknownOf(table).length" class="text-caption mt-1 mb-0">
          Sin datos de costo: {{ unknownOf(table).join(', ') }}. El margen («≤») es un máximo.
        </p>
      </div>
    </div>
  </div>
</template>

<script>
import { formatMoney } from '../utils/b2b-quotes.utils';
import { pct, serviceName } from '../utils/actuarial.utils';

const EXTRA_SERVICE_NAMES = { TRASLADO: 'Traslado por accidente traumático' };

/** Margin of each partner plan at the partner's prices, tier by tier, with the actuarial cost. */
export default {
  name: 'ActuarialPartnerMargins',
  props: {
    offers: { type: Array, default: () => [] },
    currency: { type: String, default: 'CLP' }
  },
  methods: {
    money(value) {
      return formatMoney(value, this.currency);
    },
    marginText(cell) {
      return cell.unknownServices.length ? `≤ ${pct(cell.margin)}` : pct(cell.margin);
    },
    unknownOf(table) {
      const codes = new Set(table.rows.flatMap((r) => r.cells.flatMap((c) => c.unknownServices)));
      return [...codes].map((code) => EXTRA_SERVICE_NAMES[code] ?? serviceName(code));
    }
  }
};
</script>

<style scoped>
.actuarial__table {
  border: 1px solid var(--pw-border);
  border-radius: 8px;
}
</style>
